module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3TiAC"))).then(() => parcelRequire('3a9aZ'));